import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxButtonComponent } from '@digipay/ngx-button';
import { RouteStateService } from '@client-monorepo/common/utilities';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { HOME_ROUTE, INVESTMENT_LIST_ROUTE } from '../../../../data-access/constants/app-routes';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';

@Component({
  selector: 'wealth-applet-campaign-start',
  standalone: true,
  imports: [CommonModule, NgxButtonComponent, NgxAppBarComponent],
  templateUrl: './campaign-successful.component.html',
  styleUrl: './campaign-successful.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignSuccessfulComponent implements OnInit {
  state: { prizeAmount: string; symbol: string; instrumentName: string };

  navigationService = inject(WealthNavigationService);
  routeState = inject(RouteStateService);

  ngOnInit(): void {
    this.state = this.routeState.getAll();
    if (!this.state.symbol) {
      this.navigationService.navigate([HOME_ROUTE]);
    }
  }

  onBackHandler() {
    this.navigationService.navigate([HOME_ROUTE]);
  }

  onViewAssets() {
    this.navigationService.navigate([INVESTMENT_LIST_ROUTE, this.state.symbol]);
  }
}
